<div class="gaze-page-container">
  <!-- Gaze Header -->
  <header class="gaze-header">
    <div class="back-btn-container">
      <button class="back-btn" (click)="OnClickClose()" aria-label="Go back">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="#2d6a70" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
     <div class="gaze-logo-wrapper">
      <h1 class="gaze-logo">Gaze</h1>
      <span class="gaze-sublogo">
         <span class="by-text">by</span> WindowSwap</span>
    </div>
    <div class="gaze-page-subtitle">{{ constants.GAZE_SUPPORT_CONTENT.headerTitle }}</div>
  </header>

  <!-- Gaze Content Body -->
  <main class="gaze-content-body">
    <div class="gaze-content-container">
      
      <!-- Need Help Card -->
      <div class="need-help-card">
        <h2 class="card-title">{{ constants.GAZE_SUPPORT_CONTENT.card.title }}</h2>
        <p class="card-desc">{{ constants.GAZE_SUPPORT_CONTENT.card.description }}</p>
        <a [href]="'mailto:' + constants.GAZE_SUPPORT_CONTENT.card.email" class="email-btn">
          {{ constants.GAZE_SUPPORT_CONTENT.card.email }}
        </a>
      </div>

      <!-- How Can We Help Section -->
      <section *ngFor="let section of constants.GAZE_SUPPORT_CONTENT.sections" class="info-section">
        <h2 class="section-title">{{ section.title }}</h2>
        <ul class="bullet-list">
          <li *ngFor="let item of section.items">{{ item }}</li>
        </ul>
      </section>

      <!-- Frequently Asked Questions -->
      <section class="faq-section">
        <h2 class="section-title">{{ constants.GAZE_SUPPORT_CONTENT.faqTitle }}</h2>
        <div class="faq-list">
          <div *ngFor="let faq of constants.GAZE_SUPPORT_CONTENT.faqs; let last = last" class="faq-item" [class.no-border]="last">
            <h3 class="faq-question">{{ faq.question }}</h3>
            <p class="faq-answer">{{ faq.answer }}</p>
          </div>
        </div>
      </section>

      <!-- More Resources Section -->
      <section class="resources-section">
        <h2 class="section-title">{{ constants.GAZE_SUPPORT_CONTENT.resourcesTitle }}</h2>
        <div class="resources-list">
          <ng-container *ngFor="let resource of constants.GAZE_SUPPORT_CONTENT.resources">
            <!-- Routed Link -->
            <a *ngIf="resource.route" [routerLink]="resource.route" class="resource-card">
              <span class="resource-text">{{ resource.text }}</span>
              <svg class="chevron-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18L15 12L9 6" stroke="#2d6a70" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
            <!-- External Link -->
            <a *ngIf="resource.url" [href]="resource.url" target="_blank" rel="noopener noreferrer" class="resource-card">
              <span class="resource-text">{{ resource.text }}</span>
              <svg class="chevron-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18L15 12L9 6" stroke="#2d6a70" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
            <div class="resource-divider"></div>
          </ng-container>
        </div>
      </section>

      <!-- Standard Gaze Footer -->
      <footer class="gaze-footer">
        <p class="footer-company">{{ constants.GAZE_FOOTER_CONTENT.footer.company }}</p>
        <p class="footer-copyright">{{ constants.GAZE_FOOTER_CONTENT.footer.copyright }}</p>
      </footer>

    </div>
  </main>
</div>
